/* eslint-disable */
import { CalendarIcon, ChevronLeft, Pen, X } from 'lucide-react'
import { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import PlaceOrderBg from '../../assets/images/PlaceOrderBg.png'
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../../Components/ui/tabs'
import { Label } from '../../Components/ui/label'
import { Input2 } from '../../Components/ui/input2'
import { Button } from '../../Components/ui/button'
import { toCurrency } from '../../utils/CurrencyUtil'
import { Popover, PopoverContent, PopoverTrigger } from '../../Components/ui/popover'
import { useModal } from '../../hooks/use-modal-store'
import env from '../../env/env'
import { post } from '../../http/restservice'
import { userDetailsState } from '../LoginState'
import { useRecoilState, useRecoilValueLoadable, useSetRecoilState } from 'recoil'
import { messageModalState } from '../../store/Feedback'
import { addNumberSuffix, addMonth, monthNames, formatIndianNumber } from '../../utils/Util'
import { Card, CardContent } from '../../Components/ui/card'
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '../../Components/ui/alert-dialog'

import {
  Sheet,
  SheetClose,
  SheetContent,
  SheetDescription,
  SheetFooter,
  SheetHeader,
  SheetTitle,
} from '../../Components/ui/sheet'
import { BankDetails } from '../../store/AccountDetailsStore'
import { AccountBalance } from '@mui/icons-material'
import useMediaQuery from '../../hooks/useMediaQuery'
import { getUserDetails } from '../../utils/AuthUtil'
import { useErrorPopup } from '../../hooks/useErrorPopup'
import OTPVerification from '../FirstIdeas/OTPVerification'
import PostHogTracker from '../../utils/PostHogTracker'
import OrderOtpVerification from '../FirstIdeas/OrderOtpVerification'

const MFPlaceOrder = () => {
  const location = useLocation()

  const isDesktop = useMediaQuery('(min-width: 1024px)')
  const [fundDetails] = useState(location?.state?.fundDetails)

  const sipDates = [3, 5, 10, 15, 22, 25]
  const navigate = useNavigate()
  const { onOpen } = useModal()
  const [tabValue, setTabValue] = useState(location.state.destination || 'One-Time')

  const [selectedDay, setSelectedDay] = useState(5)
  const [oneTimeAmount, setOneTimeAmount] = useState(Math.floor(fundDetails?.minInvt) || 0)
  const [oneTimeAmountInput, setOneTimeAmountInput] = useState('0')
  const [sipAmount, setSipAmount] = useState(Math.floor(fundDetails?.minSipAmount) || 0)
  const [sipAmountInput, setSipAmountInput] = useState('0')
  const [isSIPLoading, setIsSIPLoading] = useState(false)
  const [isOneTimeLoading, setIsOneTimeLoading] = useState(false)
  const setMessageModalState = useSetRecoilState(messageModalState)
  const [userDetails, setUserDetails] = useRecoilState(userDetailsState)
  const email = userDetails?.email

  const userData = JSON.parse(localStorage.getItem('userData'))

  const clientCode = userDetails ? userDetails?.uid?.split('-')[0] : userData?.uid?.split('-')[0]

  const [showMfSipMandatePopup, setShowMfSipMandatePopup] = useState(false)
  const [sipDate, setSipDate] = useState('')

  const [nextSipDay, nextSipMonth, nextSipYear] = sipDate.split('/')
  const [redirectURL, setRedirectURL] = useState('')
  const [callMandateAuthURL, setCallMandateAuthURL] = useState(false)

  const currentDate = new Date()
  const today = currentDate.getDate()
  const month = currentDate.getMonth() + 1
  const year = currentDate.getFullYear()
  const nextDay1 = new Date()
  nextDay1.setDate(today + 1)
  const nextDay2 = new Date()
  nextDay2.setDate(today + 2)

  const { contents: bankDetails } = useRecoilValueLoadable(BankDetails)

  const [mandateId, setMandateId] = useState('')
  const [timeLeft, setTimeLeft] = useState(120)
  const { showError } = useErrorPopup()
  const [mandateStatus, setMandateStatus] = useState(null)
  const [isOpen, setIsOpen] = useState(false)
  const [doXSIP, setDoXSIP] = useState(false)
  const [mandateRegResponse, setMandateRegResponse] = useState(null)
  const [openOTPPopup, setOpenOTPPopup] = useState(false)

  useEffect(() => {
    setUserDetails(getUserDetails())

    // Track investment type selected when page loads
    if (tabValue && fundDetails) {
      PostHogTracker.investmentTypeSelected(tabValue, fundDetails.schemeName)
    }
  }, [])

  // Track amount changes
  useEffect(() => {
    if (oneTimeAmount >= fundDetails?.minInvt) {
      PostHogTracker.lumpsumAmountEntered(oneTimeAmount, fundDetails?.schemeName)
    }
  }, [oneTimeAmount])

  useEffect(() => {
    if (sipAmount >= fundDetails?.minSipAmount) {
      PostHogTracker.sipAmountEntered(sipAmount, fundDetails?.schemeName)
    }
  }, [sipAmount])

  // Track SIP date selection
  useEffect(() => {
    if (selectedDay && fundDetails) {
      PostHogTracker.sipDateSelected(selectedDay, fundDetails?.schemeName)
    }
  }, [selectedDay])

  useEffect(() => {
    // initialize formatted display values
    setOneTimeAmountInput(toCurrency(Number(oneTimeAmount || 0)))
    setSipAmountInput(toCurrency(Number(sipAmount || 0)))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handleOneTimeInputChange = (e) => {
    const raw = (e?.target?.value || '').toString().replace(/[^0-9]/g, '')
    const numeric = raw ? Number(raw) : 0
    setOneTimeAmount(numeric)
    setOneTimeAmountInput(toCurrency(numeric))
  }

  const handleSipInputChange = (e) => {
    const raw = (e?.target?.value || '').toString().replace(/[^0-9]/g, '')
    const numeric = raw ? Number(raw) : 0
    setSipAmount(numeric)
    setSipAmountInput(toCurrency(numeric))
  }

  const [src, setSrc] = useState('')
  const handleError = () => {
    setSrc(null)
  }

  let ifscCode = bankDetails?.ifscCode
  const extractedBranch = ifscCode?.match(/^[A-Za-z]{4}/)[0]?.toLowerCase()
  const iconSrc = `${env.BANK_LOGOS}/${extractedBranch}/symbol.svg`
  useEffect(() => {
    setSrc(iconSrc)
  }, [iconSrc])

  useEffect(() => {
    const handlePolling = async () => {
      if (callMandateAuthURL && mandateId) {
        // Check if it's time to call the eMandateAuthURL
        if (timeLeft % 10 === 0 || timeLeft === 0) {
          try {
            const eMandateResponse = await getEMandateAuthURL(mandateId)

            if (eMandateResponse.Status == 100) {
              setTimeLeft(-10)
              handleSuccessfulEMandate(eMandateResponse)
              return
            }

            if (timeLeft < 0 && eMandateResponse.Status != 100) {
              handleFailedEMandate()
            }
          } catch (error) {
            console.error('Error in eMandateAuthURL:', error)
            handleFailedEMandate()
          }
        }

        // Countdown logic
        if (timeLeft > 0) {
          const timerId = setTimeout(() => {
            setTimeLeft((prevTime) => prevTime - 1)
          }, 1000)

          // Cleanup timeout
          return () => clearTimeout(timerId)
        }
      }
    }

    handlePolling() // Call the polling function
  }, [callMandateAuthURL, timeLeft])

  useEffect(() => {
    const startPolling = (mandateId) => {
      const pollingDuration = 600 // Total duration in seconds (10 minutes)
      const pollingInterval = 10 // Interval in seconds
      let timeLeft = pollingDuration

      // Start the polling
      const intervalId = setInterval(async () => {
        if (timeLeft <= 0) {
          clearInterval(intervalId) // Stop polling after 10 minutes
          return
        }

        console.log(`Time left: ${timeLeft} seconds`)

        // Execute polling logic at each 10-second interval
        try {
          const response = await getMandateDeatils(mandateId)

          if (response.isError) {
            setShowMfSipMandatePopup(false)
            setMessageModalState({
              message: 'Error occurred while fetching mandate details or processing e-Mandate',
              severity: 'error',
            })
            clearInterval(intervalId) // Stop polling on error
            return
          }

          if (!response.isError) {
            setMandateStatus(response.MandateDetails[0].status)
          }

          // if (!response.isError && response.MandateDetails[0].status === 'UNDER PROCESSING') {
          //   onOpen('openPopup', {
          //     title: 'Mandate Processing!',
          //     message:
          //       'Your mandate is currently being processed and will be approved within 2 working days. Once approved, you can place your SIP order.',
          //     severity: 'info',
          //   })

          //   clearInterval(intervalId) // Stop polling on success
          //   return
          // }

          if (
            !response.isError &&
            (response.MandateDetails[0].status.includes('APPROVED') ||
              response.MandateDetails[0].status.includes('UNDER PROCESSING') ||
              response.MandateDetails[0].status.includes('RECEIVED BY EXCHANGE'))
          ) {
            setMandateStatus(response.MandateDetails[0].status)
            await handleXSIP(mandateId, response.MandateDetails[0].status)
            clearInterval(intervalId) // Stop polling on success
            return
          }

          timeLeft -= pollingInterval
        } catch (error) {
          console.error('Error in eMandateAuthURL:', error)
          handleFailedEMandate()
          clearInterval(intervalId) // Stop polling on error
          return
        }

        // Decrease time left
        timeLeft -= pollingInterval
      }, pollingInterval * 1000) // Convert interval to milliseconds

      return intervalId // Return interval ID for cleanup
    }

    let intervalId
    if (redirectURL) {
      intervalId = startPolling(mandateId, redirectURL)
    }

    // Cleanup function to clear interval on unmount
    return () => {
      if (intervalId) {
        clearInterval(intervalId)
        console.log('Interval cleared on unmount')
      }
    }
  }, [redirectURL, mandateId])

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    })
  }, [])

  useEffect(() => {
    const res = addMonth(today, selectedDay)
    setSipDate(res)
  }, [selectedDay, today])

  const getDynamicErrorMessage = (dataString) => {
    const reason = dataString?.split('|')[6] || ''

    const SupportNote = (
      <>
        <br />
        <span className='text-gray-500'>To update your details, please contact support.</span>
      </>
    )

    if (reason.includes('NOMINEE'))
      return (
        <>
          Nominee authentication is pending. Please complete nominee verification to proceed.
          {SupportNote}
        </>
      )

    if (reason.includes('ELOG'))
      return (
        <>
          E-log verification is pending. Please complete the e-log process before placing an order.
          {SupportNote}
        </>
      )

    if (reason.includes('FATCA'))
      return (
        <>
          Your FATCA declaration is pending. Please update your FATCA details to continue.
          {SupportNote}
        </>
      )

    if (reason.includes('BANK'))
      return (
        <>
          Bank verification failed. Please check your bank details and try again.
          {SupportNote}
        </>
      )

    if (reason.includes('KYC'))
      return (
        <>
          KYC verification is incomplete. Please complete your KYC to proceed.
          {SupportNote}
        </>
      )

    return <>An unknown error occurred while placing your order. Please try again later.</>
  }

  const placeOneTimeOrder = async () => {
    try {
      setIsOneTimeLoading(true)

      const payload = {
        orderType: 'PURCHASE',
        schemeCode: fundDetails?.bseSchemeCode,
        clientCode: clientCode?.toUpperCase(),
        orderVal: oneTimeAmount,
        phoneNumber: formatIndianNumber(userDetails?.phoneNumber),
      }

      const response = await post('mutualfundservice/api/bseStar/mfOrder/order', payload)
      setIsOneTimeLoading(false)

      if (response?.isError) {
        // Track order validation failure
        PostHogTracker.orderValidationFailed(
          fundDetails?.schemeName,
          oneTimeAmount,
          response?.response?.data?.message || 'Order failed',
        )
        showError(
          'Order Placement Failed',
          getDynamicErrorMessage(response?.response?.data),
          () => {},
        )
        return
      }

      const orderNumberMatch = response?.data?.match(/ORDER NO: (\d+)/)

      const orderNumber = orderNumberMatch ? orderNumberMatch[1] : null

      if (response.status === 'SUCCESS' && orderNumber) {
        // Track order validation success
        PostHogTracker.orderValidationSuccess(fundDetails?.schemeName, oneTimeAmount, 'One-Time')

        const paymentPayload = {
          clientCode: clientCode?.toUpperCase(),
          orderNumber: orderNumber,
          totalAmount: oneTimeAmount,
        }

        // Track payment initiated
        PostHogTracker.paymentInitiated(orderNumber, oneTimeAmount, 'pending')

        navigate('/dashboard/mutual-funds/order-payment', {
          state: {
            paymentPayload,
            orderNumber,
            orders: payload,
          },
        })
      } else {
        // Track order validation failure
        PostHogTracker.orderValidationFailed(
          fundDetails?.schemeName,
          oneTimeAmount,
          'No order number received',
        )
        showError(
          'Order Placement Failed',
          'An error occurred while placing your one-time order. Please try again or contact support for assistance.',
          () => {},
        )
      }
    } catch (error) {
      console.log('🚀 ~ placeOneTimeOrder ~ error:', error)
    }
  }

  const placeSIPOrder = async () => {
    try {
      setIsSIPLoading(true)

      // Track mandate check initiated
      PostHogTracker.mandateCheckInitiated(sipAmount)

      const payload = {
        clientCode: clientCode?.toUpperCase(),
        amount: sipAmount.toString(),
        sipStartDate: sipDate,
        mandateType: 'UNIVERSAL',
        phoneNumber: formatIndianNumber(userDetails?.phoneNumber),
      }

      const response = await post(
        'mutualfundservice/api/bseStar/mfUpload/mandateRegistration',
        payload,
      )

      if (response?.isError) {
        // Track mandate setup failure
        PostHogTracker.orderValidationFailed(
          fundDetails?.schemeName,
          sipAmount,
          response?.response?.data?.message || 'Mandate registration failed',
        )
        showError(
          'Order Placement Failed',
          getDynamicErrorMessage(response?.response?.data),
          () => {},
        )
        return
      }

      if (
        (response?.mandateStatus === 'NEW' || response?.mandateStatus === null) &&
        response?.status === 'SUCCESS'
      ) {
        // Track new mandate required
        PostHogTracker.newMandateRequired(sipAmount)
        PostHogTracker.mandateSetupInitiated(sipAmount, bankDetails?.bankName)

        const sip = {
          sipData: [{ schemeCode: fundDetails.bseSchemeCode, installmentAmount: sipAmount }],
          clientCode: clientCode?.toUpperCase(),
          startDate: sipDate,
          mandateId: mandateId,
        }

        sessionStorage.setItem(
          'userSIPs',
          JSON.stringify({
            sip: sip,
          }),
        )

        navigate('/dashboard/mutual-funds/mandate', {
          state: {
            mandateId: response?.mandateId,
            clientCode: clientCode?.toUpperCase(),
            sipDate: sipDate,
            isIndividual: true,
            isBasketOrder: false,
            isActionPlan: false,
            sip: sip,
          },
        })
      }

      if (
        response?.status === 'SUCCESS' &&
        response?.mandateStatus !== 'NEW' &&
        response?.mandateStatus !== null &&
        response?.alreadyExists
      ) {
        // Track existing mandate found
        PostHogTracker.existingMandateFound(response?.mandateId, sipAmount)
        setMandateRegResponse(response)
        setIsOpen(true)
      }
    } catch (error) {
      showError(
        'SIP Registration Failed',
        'We encountered an issue while registering your SIP. Please try again or contact support for assistance.',
        () => {},
      )
    }
  }

  // Helper function to handle existing mandate registration
  const handleXSIP = async (mandateId, status) => {
    const payload = {
      sipData: [{ schemeCode: fundDetails.bseSchemeCode, installmentAmount: sipAmount }],
      clientCode: clientCode?.toUpperCase(),
      startDate: sipDate,
      mandateId: mandateId,
    }

    try {
      // Track XSIP registration initiated
      PostHogTracker.sipRegistrationStarted(fundDetails.schemeName, sipAmount, sipDate)

      const xSIPRegistration = await post(
        'mutualfundservice/api/illusion/sipRegistrationOrder',
        payload,
      )

      setShowMfSipMandatePopup(false)

      if (xSIPRegistration?.isError) {
        // Track XSIP registration failure
        PostHogTracker.sipRegistrationFailed(
          fundDetails.schemeName,
          xSIPRegistration?.response?.data?.message || 'Registration failed',
        )

        showError(
          'SIPs Registration Failed',
          'We encountered an issue while registering your SIP. Please try again or contact support for assistance.',
          () => {},
        )
        return
      }

      if (
        xSIPRegistration.status === 'SUCCESS' &&
        xSIPRegistration?.data?.orderStatus === 'ACTIVE'
      ) {
        // Track XSIP registration success
        PostHogTracker.sipRegistrationSuccess(fundDetails.schemeName, sipAmount)

        PostHogTracker.investmentConfirmationViewed(fundDetails.schemeName, sipAmount, 'SIP')

        onOpen('openPopup', {
          title: 'SIP Registration Successful! ',
          message:
            'SIP Registration Successful! 🎉 Your SIP registration has been completed successfully.',
          severity: 'success',
        })
      }
    } catch (error) {
      console.log('Error registering XSIP:', error)

      // Track XSIP registration error
      PostHogTracker.sipRegistrationError(fundDetails.schemeName, error.message)
    }
  }

  // Helper function to get eMandate Auth URL
  const getEMandateAuthURL = async (mandateId) => {
    const eMandatePayload = {
      clientCode: clientCode?.toUpperCase(),
      mandateId,
      loopBackUrl: `${env.LOOPBACK_URL}dashboard/mutual-funds/place-order`,
    }

    return await post('mutualfundservice/api/bseStar/mfWebService/eMandateAuthURL', eMandatePayload)
  }

  const getMandateDeatils = async (mandateId) => {
    const today = new Date()
    const formattedDate = today.toLocaleDateString('en-GB')?.replace(/\//g, '/')

    const payload = {
      fromDate: '01/10/2024',
      toDate: formattedDate,
      clientCode: clientCode?.toUpperCase(),
      mandateId: mandateId,
    }

    return await post('mutualfundservice/api/bseStar/mfWebService/mandateDetails', payload)
  }

  const handleSuccessfulEMandate = (eMandateResponse) => {
    setRedirectURL(eMandateResponse.ResponseString)
    setCallMandateAuthURL(true)
    setIsSIPLoading(false)
  }

  // Helper function to handle failed eMandate response
  const handleFailedEMandate = () => {
    setShowMfSipMandatePopup(false)
    showError(
      'SIP Registration Failed',
      'We encountered an issue while registering your SIP. Please try again or contact support for assistance.',
      () => {},
    )
  }

  const handleXSIPConfirm = async () => {
    if (mandateRegResponse) {
      setIsOpen(false)
      const mandateDetails = await getMandateDeatils(mandateRegResponse.mandateId)
      await handleXSIP(mandateRegResponse.mandateId, mandateDetails.MandateDetails[0].mandateStatus)
      setDoXSIP(false)
      return
    }
  }

  function getFundReturn(fundPortfolio) {
    if (fundPortfolio?.threeYrRet != null && fundPortfolio?.threeYrRet != 0) {
      return `${fundPortfolio.threeYrRet.toFixed(2)}`
    } else if (fundPortfolio?.fiveYrRet != null && fundPortfolio?.fiveYrRet != 0) {
      return `${fundPortfolio.fiveYrRet.toFixed(2)}`
    } else if (fundPortfolio?.oneYrRet != null && fundPortfolio?.oneYrRet != 0) {
      return `${fundPortfolio.oneYrRet.toFixed(2)}`
    } else {
      return 0
    }
  }

  function getFundYear(fundPortfolio) {
    if (fundPortfolio?.threeYrRet != null && fundPortfolio?.threeYrRet != 0) {
      return `3Y`
    } else if (fundPortfolio?.fiveYrRet != null && fundPortfolio?.fiveYrRet != 0) {
      return `5Y`
    } else if (fundPortfolio?.oneYrRet != null && fundPortfolio?.oneYrRet != 0) {
      return `1Y`
    } else {
      return 0
    }
  }

  const generateOTP = async () => {
    const response = await post(
      `${env.API_URL}mutualfundservice/api/mutualFund/sendTransactionalOtp`,
      {
        phoneNumber: userDetails?.phoneNumber,
        email: email.includes('fabits') ? '' : email,
      },
    )

    if (response.isError) {
      showError('OTP Error', 'Failed to generate OTP. Please try again later.', () => {})
      PostHogTracker.buttonClicked('Order OTP Resend Failed', {
        action: 'Order OTP Resend Failed',
        page_name: 'Action Center Orders Page',
      })
    }

    if (!response.isError) {
      PostHogTracker.buttonClicked('Order OTP Resend Success', {
        action: 'Order OTP Resend Successful',
        page_name: 'Action Center Orders Page',
      })
      setOpenOTPPopup(true)
    }
  }

  const disableOneTime =
    !oneTimeAmount ||
    +oneTimeAmount < fundDetails?.minInvt ||
    oneTimeAmount?.toString()?.includes('.')

  const disableSIP =
    !sipAmount || +sipAmount < fundDetails?.minSipAmount || sipAmount?.toString()?.includes('.')

  const handleSipOrOT = () => {
    tabValue === 'SIP' ? placeSIPOrder() : placeOneTimeOrder()
  }

  return (
    <>
      <div className='bg-white fabits-order-page'>
        <div className='max-w-[1128px] mx-auto min-h-screen pb-12 fabits-order-shell'>
          <div
            className='flex gap-x-1 items-center font-semibold cursor-pointer lg:py-2.5 p-4 lg:px-0 fabits-order-header'
            onClick={() => navigate(-1)}
          >
            <ChevronLeft className='h-5 w-5' />
            Place Order
          </div>

          <div className='max-w-[360px] mx-auto h-full flex flex-col gap-y-12 justify-between fabits-order-panel'>
            <div className='h-[170px] w-full bg-cover flex justify-center items-center p-2 z-0 relative fabits-order-ticket'>
              <div
                className='absolute inset-0 bg-cover w-full h-full fabits-order-ticket-bg'
                style={{ backgroundImage: `url(${PlaceOrderBg})` }}
              />
              <div
                className='absolute inset-0 fabits-order-ticket-wash'
                style={{
                  background: 'linear-gradient(180deg, #FFFFFF 0%, rgba(255, 255, 255, 0) 100%)',
                  // boxShadow: '0px 16px 24px rgba(65, 85, 141, 0.08)',
                }}
              />
              <div className='flex items-center space-x-4 z-10 fabits-order-ticket-content'>
                <img
                  src={`${env.MF_LOGOS_URL}/${fundDetails?.amcCode}.png`}
                  alt={fundDetails?.legalName}
                  className='w-12 h-12 border rounded-lg fabits-order-fund-logo'
                />
                <div>
                  <h3
                    className='font-semibold text-sm leading-tight text-wrap w-48 fabits-order-fund-name'
                    style={{ textWrap: 'pretty' }}
                  >
                    {fundDetails?.legalName
                      ? fundDetails?.legalName?.replace(/Fund.*$/, 'Fund')
                      : fundDetails?.sName
                      ? fundDetails?.sName?.replace(/Fund.*$/, 'Fund')
                      : fundDetails?.sname?.replace(/Fund.*$/, 'Fund')}
                  </h3>
                  <p className='text-sm text-muted-foreground fabits-order-return-line'>
                    {getFundYear(fundDetails)} returns{' '}
                    <span className='font-bold text-green-600 fabits-order-return-value'>
                      {getFundReturn(fundDetails)}%
                    </span>
                  </p>
                </div>
              </div>
            </div>

            <Tabs
              defaultValue='One-Time'
              value={tabValue}
              onValueChange={setTabValue}
              className='fabits-order-tabs'
            >
              <TabsList className='mx-auto grid h-12 w-full grid-cols-2 rounded-[999px]'>
                <TabsTrigger value='One-Time' className='h-10 px-2 font-IBM text-sm leading-5'>
                  <span className='truncate'>One-Time</span>
                </TabsTrigger>
                <TabsTrigger value='SIP' className='h-10 px-2 font-IBM text-sm leading-5'>
                  <span className='truncate'>SIP</span>
                </TabsTrigger>
              </TabsList>
              <TabsContent value='One-Time' className='h-full'>
                <div className='flex flex-col justify-center items-center gap-1.5 mt-12 fabits-order-amount-block'>
                  <Label htmlFor='amount' className='text-black-400 text-xs fabits-order-label'>
                    Investment amount
                  </Label>
                  <Input2
                    startAdornment='₹'
                    type='text'
                    id='amount'
                    placeholder='Amount'
                    className='border-none outline-none font-DMSans font-semibold text-3xl w-auto min-w-[100px] max-w-[360px] fabits-order-amount-input'
                    style={{
                      width: `${Math.max(oneTimeAmountInput.toString().length * 24 + 80, 120)}px`,
                    }}
                    value={oneTimeAmountInput}
                    onChange={handleOneTimeInputChange}
                  />
                  {oneTimeAmount < Number(fundDetails?.minInvt) && (
                    <p className='text-xs text-error-600 text-center'>
                      Minimum first investment amount is ₹ {toCurrency(fundDetails?.minInvt)}
                    </p>
                  )}
                </div>

                <div className='flex justify-center gap-x-2 mt-6'>
                  {[1000, 2000, 3000].map((btn, index) => (
                    <Button
                      key={(index + btn).toString()}
                      size='simple'
                      className='px-3 py-[2px] rounded-[50px] bg-primary-50 hover:bg-primary-50 text-primary-500 fabits-order-chip'
                      onClick={() =>
                        setOneTimeAmount((prev) => {
                          const next = Number(prev) + btn
                          setOneTimeAmountInput(toCurrency(next))
                          return next
                        })
                      }
                    >
                      + {toCurrency(btn)}
                    </Button>
                  ))}
                </div>

                <div className='flex gap-x-2 mt-12'>
                  <Button
                    className='rounded-xl border flex-1 fabits-order-secondary-action'
                    variant='simple'
                    onClick={() => setTabValue('SIP')}
                  >
                    Add SIP
                  </Button>

                  <Button
                    className={`w-full flex-1 bg-primary-500 rounded-xl fabits-order-primary-action`}
                    loading={isOneTimeLoading}
                    onClick={generateOTP}
                  >
                    Continue
                  </Button>
                </div>
              </TabsContent>
              <TabsContent value='SIP'>
                {' '}
                <div className='flex flex-col justify-center items-center gap-1.5 mt-12 fabits-order-amount-block'>
                  <Label htmlFor='amount' className='text-black-400 text-xs fabits-order-label'>
                    Investment amount
                  </Label>
                  <Input2
                    startAdornment='₹'
                    type='text'
                    id='amount'
                    placeholder='Amount'
                    className='border-none outline-none font-DMSans font-semibold text-3xl mx-auto w-auto min-w-[100px] max-w-[360px] fabits-order-amount-input'
                    style={{
                      width: `${Math.max(sipAmountInput.toString().length * 24 + 80, 120)}px`,
                    }}
                    value={sipAmountInput}
                    onChange={handleSipInputChange}
                  />
                  {sipAmount < Number(fundDetails?.minSipAmount) && (
                    <p className='text-xs text-error-600 text-center'>
                      Minimum SIP amount is ₹ {sipAmount === 0 ? 100 : fundDetails?.minSipAmount}
                    </p>
                  )}
                </div>
                <div className='flex justify-center gap-x-2 mt-6'>
                  {[1000, 2000, 3000].map((btn, index) => (
                    <Button
                      key={(index + btn).toString()}
                      size='simple'
                      className='px-3 py-[2px] rounded-[50px] bg-primary-50 hover:bg-primary-50 text-primary-500 fabits-order-chip'
                      onClick={() =>
                        setSipAmount((prev) => {
                          const next = Number(prev) + btn
                          setSipAmountInput(toCurrency(next))
                          return next
                        })
                      }
                    >
                      + {toCurrency(btn)}
                    </Button>
                  ))}
                </div>
                <div className='mt-12'>
                  <Label className='text-sm text-black-300 fabits-order-label'>
                    Select SIP Date
                  </Label>
                  <Popover>
                    <PopoverTrigger asChild>
                      <Button
                        variant={'outline'}
                        className='pl-3 font-normal border-none bg-primary-50 rounded-lg w-full flex justify-between max-w-[360px] mx-auto fabits-order-date-button'
                      >
                        <span className='text-primary-500 flex items-center gap-x-2'>
                          <CalendarIcon className='ml-auto h-4 w-4 opacity-50' />
                          {addNumberSuffix(+selectedDay)} of every month
                        </span>

                        <Pen className='h-4 w-4 text-primary-500' />
                      </Button>
                    </PopoverTrigger>
                    <PopoverContent className='p-0 w-auto rounded-full' align='center' side='top'>
                      <div className='flex gap-x-2 p-2'>
                        {sipDates.map((day, index) => (
                          <Button
                            key={(day + index).toString()}
                            className={`h-8 w-8 rounded-full inline-block ${
                              selectedDay !== +day
                                ? 'bg-white border border-primary-50 text-black-400 hover:bg-primary-50'
                                : 'text-white'
                            }`}
                            size='simple'
                            // disabled={
                            //   +day === today ||
                            //   +day === nextDay1.getDate() ||
                            //   +day === nextDay2.getDate()
                            // }
                            onClick={() => setSelectedDay(+day)}
                          >
                            {day}
                          </Button>
                        ))}
                      </div>
                    </PopoverContent>
                  </Popover>

                  {/* <div className='flex justify-between items-center w-full mt-6'>
                  <Label className='text-nowrap text-sm'>Add annual step-up</Label>
                  <Input className='max-w-[72px]' endAdornment='%' />
                </div> */}

                  <Card className='w-full max-w-md mx-auto mt-6 fabits-order-info-card'>
                    {/* <CardHeader>
                        <CardTitle className='text-base font-semibold'>SIP Information</CardTitle>
                      </CardHeader> */}
                    <CardContent className='space-y-4 p-3'>
                      <div className='flex justify-between'>
                        {/* <div className='flex flex-col'>
                            <p className='text-sm font-medium text-black-300'>First Instalment</p>
                            <p className='text-sm font-semibold text-black-400'>Initiated Now</p>
                          </div> */}
                        <div className='flex flex-col'>
                          <p className='text-sm font-medium text-black-300'>Next Instalment</p>
                          <p className='text-sm font-semibold text-black-400'>
                            {addNumberSuffix(+nextSipDay)} {monthNames[nextSipMonth - 1]}{' '}
                            {nextSipYear}
                          </p>
                        </div>
                      </div>
                      <ul className='list-disc pl-5 space-y-2 text-black-300 text-xs'>
                        {/* <li>Your 1st SIP instalment will be initiated now.</li> */}
                        <li>
                          All future SIP instalments will be paid on {addNumberSuffix(selectedDay)}{' '}
                          of every month. Dates may vary in case of holidays.
                        </li>
                        {/* <li>
                            Future installments must start at least 30 days after the SIP creation
                            date, as per BSE guidelines.
                          </li> */}
                      </ul>
                    </CardContent>
                  </Card>
                </div>
                {/* <div className='my-6 flex justify-center'>
                <Button
                  variant='link'
                  size='simple'
                  className='text-primary-500 p-0 border-b border-dashed border-primary-500 rounded-none hover:no-underline'
                  onClick={() => onOpen('openMFBreakdown', { displayNavbar })}
                >
                  View detailed breakdown
                  <ChevronDown className='h-4 w-4 ml-1' />
                </Button>
              </div> */}
                <div className='flex gap-x-2 mt-6'>
                  <Button
                    disabled={oneTimeAmount === 0 || !oneTimeAmount}
                    className='rounded-xl border flex-1 fabits-order-secondary-action'
                    variant='simple'
                    onClick={() => setTabValue('One-Time')}
                  >
                    Add One Time amount
                  </Button>

                  <Button
                    className={`w-full flex-1 bg-primary-500 rounded-xl fabits-order-primary-action`}
                    loading={isSIPLoading}
                    onClick={generateOTP}
                  >
                    Continue
                  </Button>
                </div>
              </TabsContent>
            </Tabs>
          </div>
        </div>
      </div>

      {isDesktop ? (
        <AlertDialog open={isOpen} onOpenChange={setIsOpen}>
          <AlertDialogContent className='min-h-[430px] flex flex-col gap-6'>
            <AlertDialogHeader className={'gap-6'}>
              <AlertDialogTitle>
                <div className='relative justify-between'>
                  <div className='text-start'>
                    <h1 className='text-black-500 font-semibold text-2xl font-DMSans'>
                      Confirm SIP setup
                    </h1>
                  </div>
                  <div
                    className='cursor-pointer absolute right-0 top-0'
                    onClick={() => {
                      setIsOpen(false), setIsSIPLoading(false)
                    }}
                  >
                    <X className='h-5 w-5 ' /> <span className='sr-only'>Close</span>
                  </div>
                </div>
                <p className='text-black-400 font-normal text-base text-start font-DMSans'>
                  We will use your preexisting mandate to set up your new SIP.
                </p>
              </AlertDialogTitle>
              <AlertDialogDescription className='text-start flex flex-col gap-6'>
                <div className='flex border rounded-[16px] justify-between p-4'>
                  <div className='flex gap-2'>
                    <img
                      src={`${env.MF_LOGOS_URL}/${fundDetails?.amcCode}.png`}
                      alt={fundDetails?.amcName}
                      className='w-12 h-12 border rounded-lg'
                    />
                    <div className='font-DMSans font-semibold'>
                      <h1 className='text-black-500 text-base'>
                        {fundDetails?.legalName
                          ? fundDetails?.legalName?.replace(/Fund.*$/, 'Fund')
                          : fundDetails?.sName
                          ? fundDetails?.sName?.replace(/Fund.*$/, 'Fund')
                          : fundDetails?.sname?.replace(/Fund.*$/, 'Fund')}
                      </h1>
                      <p className='text-black-400 text-sm'>{fundDetails?.amcName}</p>
                    </div>
                  </div>
                  <h1 className='font-DMSans font-semibold text-black-500 text-xl text-nowrap'>
                    ₹ {toCurrency(sipAmount)}
                  </h1>
                </div>
                <div>
                  <h1 className='text-black-400 text-base font-normal font-DMSans'>Bank</h1>
                  <div className=' border rounded-[16px] p-4 mt-2'>
                    <div className='flex gap-2'>
                      <div className='rounded-full border border-[#D3DBEC] h-11 w-11 flex justify-center items-center'>
                        {src ? (
                          <img
                            src={src}
                            alt='bank logos'
                            onError={handleError}
                            height={24}
                            width={24}
                          />
                        ) : (
                          <AccountBalance className='text-primary-200 w-5 h-5' />
                        )}
                      </div>
                      <div>
                        <h1 className='font-DMSans font-semibold text-black-500 text-base'>
                          {bankDetails && bankDetails?.accountHolderName}
                        </h1>
                        <p className='font-DMSans'>
                          <span className='text-black-400 text-sm font-semibold'>
                            {bankDetails && bankDetails?.bankName}{' '}
                          </span>
                          <span className='text-black-400 text-sm font-medium'>
                            ending in{' '}
                            <span className='font-semibold'>
                              {' '}
                              {bankDetails &&
                                bankDetails?.accountNo &&
                                bankDetails?.accountNo?.slice(-4)}
                            </span>
                          </span>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </AlertDialogDescription>
            </AlertDialogHeader>
            <AlertDialogFooter>
              <AlertDialogAction
                className='w-full text-white text-sm font-medium font-DMSans bg-primary-500 hover:bg-primary-400'
                onClick={handleXSIPConfirm}
              >
                Set Up
              </AlertDialogAction>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialog>
      ) : (
        <Sheet open={isOpen} onOpenChange={setIsOpen}>
          <SheetContent
            className='flex flex-col gap-6'
            style={{ borderRadius: '24px 24px 0px 0px' }}
            side={'bottom'}
          >
            <SheetHeader className={'gap-6'}>
              <SheetTitle>
                <div className='relative justify-between'>
                  <div className='text-start'>
                    <h1 className='text-black-500 font-semibold text-xl font-DMSans'>
                      Confirm SIP setup
                    </h1>
                  </div>
                </div>
                <p className='text-black-400 font-normal text-sm text-start font-DMSans'>
                  We will use your preexisting mandate to set up your new SIP.
                </p>
              </SheetTitle>
              <SheetDescription className='text-start flex flex-col gap-6'>
                <div>
                  <h1 className='text-black-400 text-base font-normal font-DMSans'>Bank</h1>
                  <div className='flex border rounded-[16px] justify-between p-4 mt-2'>
                    <div className='flex gap-2'>
                      <img
                        src={`${env.MF_LOGOS_URL}/${fundDetails?.amcCode}.png`}
                        alt={fundDetails?.amcName}
                        className='w-12 h-12 border rounded-lg'
                      />
                      <div className='font-DMSans font-semibold'>
                        <h1 className='text-black-500 text-base'>
                          {' '}
                          {fundDetails?.legalName
                            ? fundDetails?.legalName?.replace(/Fund.*$/, 'Fund')
                            : fundDetails?.sName
                            ? fundDetails?.sName?.replace(/Fund.*$/, 'Fund')
                            : fundDetails?.sname?.replace(/Fund.*$/, 'Fund')}
                        </h1>
                        <p className='text-black-400 text-sm'>{fundDetails?.amcName}</p>
                      </div>
                    </div>
                    <h1 className='font-DMSans font-semibold text-black-500 text-xl text-nowrap'>
                      ₹ {toCurrency(sipAmount)}
                    </h1>
                  </div>
                </div>
                <div>
                  <h1 className='text-black-400 text-base font-normal font-DMSans'>Bank</h1>
                  <div className=' border rounded-[16px] p-4 mt-2'>
                    <div className='flex gap-2'>
                      <div className='rounded-full border border-[#D3DBEC] h-11 w-11 flex justify-center items-center'>
                        {src ? (
                          <img
                            src={src}
                            alt='bank logos'
                            onError={handleError}
                            height={24}
                            width={24}
                          />
                        ) : (
                          <AccountBalance className='text-primary-200 w-5 h-5' />
                        )}
                      </div>
                      <div>
                        <h1 className='font-DMSans font-semibold text-black-500 text-base'>
                          {bankDetails && bankDetails?.accountHolderName}
                        </h1>
                        <p className='font-DMSans'>
                          <span className='text-black-400 text-sm font-semibold'>
                            {bankDetails && bankDetails?.bankName}{' '}
                          </span>
                          <span className='text-black-400 text-sm font-medium'>
                            ending in{' '}
                            <span className='font-semibold'>
                              {' '}
                              {bankDetails &&
                                bankDetails?.accountNo &&
                                bankDetails?.accountNo?.slice(-4)}
                            </span>
                          </span>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </SheetDescription>
            </SheetHeader>
            <SheetFooter>
              <SheetClose asChild>
                <Button
                  className='w-full text-white text-sm font-medium font-DMSans bg-primary-500 hover:bg-primary-400'
                  onClick={handleXSIPConfirm}
                  type='submit'
                >
                  Set Up
                </Button>
              </SheetClose>
            </SheetFooter>
          </SheetContent>
        </Sheet>
      )}

      <OrderOtpVerification
        phoneNumber={userDetails?.phoneNumber}
        openOTPPopup={openOTPPopup}
        setOpenOTPPopup={setOpenOTPPopup}
        email={email}
        handleSipOrOT={handleSipOrOT}
      />
    </>
  )
}

export default MFPlaceOrder
